export default __webpack_public_path__ + "static/media/bkr-color.5c14b609.svg";